import { render, staticRenderFns } from "./InSituData.vue?vue&type=template&id=0d4cd998&scoped=true"
import script from "./InSituData.vue?vue&type=script&lang=js"
export * from "./InSituData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4cd998",
  null
  
)

export default component.exports